import { CHAPTERS } from "./data";
import { Reveal } from "./Reveal";
import { useContent } from "./ContentContext";
import { useTx, txtStyle } from "./siteText";

export const Story = () => {
  const { settings, resolveImg } = useContent();
  const tx = useTx();
  const chapters = settings.chapters && settings.chapters.length ? settings.chapters : CHAPTERS;
  return (
    <section id="story" className="relative py-24 md:py-32 bg-cantina-cream" data-testid="story-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <Reveal className="order-2 lg:order-1">
            <div className="relative">
              <div className="frame-img rounded-3xl border-4 border-white shadow-[0_24px_60px_rgba(23,35,59,0.14)] aspect-[4/5]">
                <img src={resolveImg(settings.images.storyMain)} alt="Blue Tequila dishes" className="w-full h-full object-cover" />
              </div>
              <div className="frame-img absolute -bottom-8 -right-4 w-[45%] aspect-square rounded-2xl border-4 border-white shadow-[0_18px_44px_rgba(23,35,59,0.18)] hidden sm:block">
                <img src={resolveImg(settings.images.storySecond)} alt="Authentic Mexican food" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -top-6 -left-4 bg-cantina-terracotta text-cantina-cream rounded-2xl px-5 py-4 shadow-lg rotate-[-6deg]">
                <span className="font-display leading-none" style={txtStyle(tx("story.badgeNumber"))}>{tx("story.badgeNumber").text}</span>
                <span className="block font-sans tracking-widest uppercase mt-1" style={txtStyle(tx("story.badgeLabel"))}>{tx("story.badgeLabel").text}</span>
              </div>
            </div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <Reveal>
              <p className="font-script text-cantina-terracotta mb-3" style={txtStyle(tx("story.eyebrow"))}>{tx("story.eyebrow").text}</p>
              <h2 className="font-display tracking-tight text-cantina-ink leading-[1.05] mb-4" style={txtStyle(tx("story.heading"))}>
                {tx("story.heading").text}
              </h2>
              <div className="dash-rule w-28 mb-10" />
            </Reveal>

            <div className="space-y-8">
              {chapters.map((ch, i) => (
                <Reveal key={ch.no} delay={i * 0.1}>
                  <div className="flex gap-5" data-testid={`story-chapter-${i}`}>
                    <span className="chapter-num text-4xl md:text-5xl font-black leading-none shrink-0 w-14">{ch.no}</span>
                    <div>
                      <h3 className="font-display text-cantina-ink mb-2" style={txtStyle(tx("story.chapterTitle"))}>{ch.title}</h3>
                      <p className="font-sans leading-relaxed text-cantina-ink/70" style={txtStyle(tx("story.chapterBody"))}>{ch.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
